import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import InputCalendarRange from '../Filters/BookingDatePicker/InputCalendarRange';
import DATE_RANGES from '../../constants/dateRanges';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';

class BookingDatePicker extends Component {
  static propTypes = {
    dateFrom: PropTypes.string,
    dateTo: PropTypes.string,
    filterName: PropTypes.string.isRequired,
    filterNameFrom: PropTypes.string.isRequired,
    filterNameTo: PropTypes.string.isRequired,
    headerText: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    onResetRange: PropTypes.func.isRequired,
    onSetRange: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
      text: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })).isRequired,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    label: PropTypes.string,
    t: PropTypes.func,
  }
  static defaultProps = {
    hasSearch: false,
    headerText: 'Date Range',
    options: DATE_RANGES,
    placeholder: 'Select Date Range',
    value: '',
    disabled: false,
  }
  static getPropsToState = (props) => {
    const value = props.value || '';
    return {
      value,
    };
  }
  constructor(props) {
    super(props);
    const state = BookingDatePicker.getPropsToState(props);
    this.state = {
      ...state,
      open: false,
    };
  }
  componentWillReceiveProps(nextProps) {
    const { value } = this.state;
    const state = BookingDatePicker.getPropsToState(nextProps);
    this.setState({ ...state }, () => {
      if (value === 'custom' && value !== state.value) {
        this.date.handleReset();
      }
    });
  }
  handleOnChange = (e, { value }) => {
    this.setState({ value }, () => {
      if (this.props.dateFrom || this.props.dateTo) {
        this.date.handleReset();
      }
      this.props.onChange(value, this.props.filterName);
    });
  }
  handleOnCustomChange = (e, { value }) => {
    const hasChange = this.state.value !== value;
    this.setState({ value, open: false }, () => {
      if (hasChange) {
        this.props.onChange(value, this.props.filterName);
      }
    });
  }
  handleClose = () => {
    this.setState({ value: '' }, () => {
      this.props.onClose(this.props.filterName);
    });
  }
  handleSetRange = (from, to) => {
    const { onSetRange } = this.props;
    const value = 'custom';
    this.setState({ value, open: from && !to }, () => {
      this.props.onChange(value, this.props.filterName);
      if (onSetRange) {
        if (from && to) {
          onSetRange(from, to);
        }
      }
    });
  }
  handleOpen = () => {
    this.setState(prevState => ({
      open: !prevState.open,
    }));
  }
  handleBlur = () => {
    this.setState({ open: false });
  }
  render() {
    const { t } = this.props;
    const classNames = ['uc-dropdown uc-dropdown-custom-selection uc-dropdown-datepicker booking'];
    if (this.state.value.length > 0) {
      classNames.push('selected');
    }
    return (
      <div className="field">
        <label className="ui" htmlFor={this.props.filterName} style={{ fontWeight: 'bold', margin: '0 0 0.28571429rem 0', fontSize: '.92857143em', display: 'block' }}>{this.props.label}</label>
        <Dropdown
          fluid
          selection
          floating
          className={classNames.join(' ')}
          open={this.state.open}
          header={this.props.headerText}
          text={this.state.value && this.props.options && this.props.options.length > 0 ?
            this.props.options.find(o => o.value === this.state.value).text
            : null}
          placeholder={this.props.placeholder}
          selectOnBlur={false}
          value={this.state.value}
          onClick={this.handleOpen}
          onBlur={this.handleBlur}
          disabled={this.props.disabled}
          name={this.props.filterName}
        >
          <Dropdown.Menu>
            {
              this.props.headerText && (
                <Dropdown.Header content={this.props.headerText} />
              )
            }
            {
              this.props.options && this.props.options.length > 0 && this.props.options.some(v => v.value === 'custom') && (
                <Dropdown.Item onClick={this.handleOnCustomChange} value="custom">
                  <Dropdown.Header style={{ marginBottom: '0.5em' }} content={t('Custom Date Range', { ns: TRANSLATION_FILES.constants })} />
                  <InputCalendarRange
                    ref={(ref) => { this.date = ref; }}
                    filterNameFrom={this.props.filterNameFrom}
                    filterNameTo={this.props.filterNameTo}
                    dateFrom={this.props.dateFrom}
                    dateTo={this.props.dateTo}
                    onReset={this.props.onResetRange}
                    onSetRange={this.handleSetRange}
                  />
                </Dropdown.Item>
              )
            }
            {
              this.props.options && this.props.options.length > 0 ?
              this.props.options.filter(v => v.value !== 'custom').map((opt, idx) => (
                <Dropdown.Item
                  key={idx}
                  value={opt.value}
                  text={t(opt.text, { ns: TRANSLATION_FILES.constants })}
                  onClick={this.handleOnChange}
                />
              ))
              : null
            }
          </Dropdown.Menu>
        </Dropdown>
      </div>
    );
  }
}

export default withTranslation(namespaces, { withRef: true })(BookingDatePicker);



// WEBPACK FOOTER //
// ./src/components/UpdatedComponents/UCBookingDatePicker.jsx